export function patchIntegers(patch: string = ""): [number, number] {
  const [maj, min] = patch.split(".");
  return [Number(maj), Number(min)];
}

export function patchVal(patch: string): number {
  if (!patch) return 0;
  const [maj, min] = patchIntegers(patch);
  return maj * 100 + min; // ex: 14.1 -> 1401
}

/**
 * Convert a static data patch (ex: 15.1.1) to a patch string (ex: 15.1).
 * @param patch - The patch string to convert.
 * @returns string.
 */
export function convertStaticPatch(patch: string): string {
  const [maj, min] = patchIntegers(patch);
  return `${maj}.${min}`;
}

export function isOldPatch(patch: string): boolean {
  return patchVal(patch) < patchVal("14.10");
}
